// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dc-btn--destroy[data-v-6a22b4ba]{border-color:#ff4a25;background:#ff6c4f !important;color:#fff}", ""]);
// Exports
module.exports = exports;
